export function sumArray(arr: any[], key: string) {
  return arr.reduce((a, b) => a + (b[key] || 0), 0)
}
